import { Component, OnInit } from '@angular/core';
import {
  AccountsLayoutComponent,
  MenuList,
} from '../../../shared/components/accounts-layout/accounts-layout.component';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-normal-user',
  standalone: true,
  templateUrl: './normal-user.component.html',
  styleUrl: './normal-user.component.scss',
  imports: [AccountsLayoutComponent],
})
export class NormalUserComponent implements OnInit{

  constructor(
    private readonly storageService : StorageService
  ){}

  ngOnInit(): void {
     this.getProfile()
  }

  getProfile(){
    // this.storageService.set('organization',authUser?.organization?.uniqueId)
  }

  menuList: MenuList = {
    menuSubLists: [
      {
        title: {
          icon: '',
          iconType: '',
          label: 'quick access',
          route: '',
        },
        items: [
          {
            icon: 'home',
            iconType: 'svgIcon',
            label: 'Dashboard',
            route: 'dashboard',
          },
          {
            icon: 'dashboard',
            iconType: 'svgIcon',
            label: 'All Meetings',
            route: 'meetings-portal',
          },
          // will add this back later when subscription works!
          // {
          //   icon: 'wallet',
          //   iconType: 'svgIcon',
          //   label: 'Subscription',
          //   route: 'manage-subscription',
          // },
          {
            icon: 'calendar_month',
            iconType: 'svgIcon',
            label: 'Calendar',
            route: 'calendar',
          },

          // {
          //   icon: 'wallet',
          //   iconType: 'svgIcon',
          //   label: 'Subscriptions',
          //   route: 'plan-and-pricing',
          //   subItems: [
          //     {
          //       icon: 'home',
          //       iconType: 'svgIcon',
          //       label: 'Plan & Pricing',
          //       route: 'plan-and-pricing',
          //     },
          //     {
          //       icon: 'dashboard',
          //       iconType: 'svgIcon',
          //       label: 'Payment & Billing',
          //       route: 'payment-and-billing',
          //     },
          //   ],
          // },
          this.storageService.get('accountType')=='ORGANIZATION' ? {
            icon: 'account_balance',
            iconType: 'svgIcon',
            label: 'My Institution',
            route: `my-organization/${this.storageService.get('organization')}`
          } : null,
        ],
      },
      {
        title: {
          icon: '',
          iconType: '',
          label: 'help & services',
          route: '',
        },
        items: [
          // {
          //   icon: 'menu_book',
          //   iconType: 'svgIcon',
          //   label: 'User Manual',
          //   route: 'user-manual',
          // },
          
          {
            icon: 'info_request',
            iconType: 'svgIcon',
            label: 'User Manual',
            route: 'user-manual',
          },
          {
            icon: 'help_desk',
            iconType: 'svgIcon',
            label: 'FAQs',
            route: 'faqs',
          },
        ],
      },
    ],
  };
}
